/* Trick or Print — il ponte fra il sito e Shopify. Generato da sito/build/tema.py.

   ⛔ TRE REGOLE, e sono il motivo per cui questo file esiste:
   1. I prezzi vengono SOLO da window.SHOPIFY. Se una cifra la mettesse il sito,
      chi guarda da un altro paese vedrebbe una valuta e ne pagherebbe un'altra.
   2. Lo sconto del sito (OFFERTA) e' SPENTO: uno sconto che Shopify non conosce
      alla cassa non esiste. Per farlo davvero si mette un «compare at price»
      sui prodotti, e arriva qui da solo come `pieno`.
   3. Il carrello e' quello di Shopify (/cart/add.js): quello vecchio viveva nel
      browser e non sapeva arrivare alla cassa.
*/
const CDN = "https://cdn.shopify.com/s/files/1/1012/9896/2759/files/";
/* ⛔ la versione delle NOSTRE immagini: senza, il CDN serve quelle vecchie.
   Non si aggiunge a `sp.img`, che e' l'immagine del prodotto e ha gia' la sua. */
const VER = "?v=501731eb2b84";
/* ⛔ I mockup che NON sono immagini di un prodotto Shopify: i due composti da noi
   e i tre volumi (che sono file dentro la Collection, non prodotti a se'). */
const MOCKUP_NOSTRI = ["halloween-coloring-collection", "complete-halloween-vault",
  "little-spooks-coloring-pages", "spooky-kids-coloring-pages", "brave-explorers-coloring-pages"];
const TP_VIDEO = {"31-days-of-halloween": "https://cdn.shopify.com/videos/c/vp/e63e763931644bbdb5b6e4a7a7798503/e63e763931644bbdb5b6e4a7a7798503.HD-720p-1.6Mbps-95857201.mp4", "brave-explorers-coloring-pages": "https://cdn.shopify.com/videos/c/vp/a232acc9ff734ae9875d9a701ac69740/a232acc9ff734ae9875d9a701ac69740.HD-720p-1.6Mbps-95857202.mp4", "candy-free-treats-mini-books": "https://cdn.shopify.com/videos/c/vp/b073964840604053bc46c7eb4c8c0695/b073964840604053bc46c7eb4c8c0695.HD-720p-1.6Mbps-95857203.mp4", "classroom-party-edition": "https://cdn.shopify.com/videos/c/vp/68011e62179049c7b6b25e40dadae299/68011e62179049c7b6b25e40dadae299.HD-720p-1.6Mbps-95857204.mp4", "editable-halloween-invitations": "https://cdn.shopify.com/videos/c/vp/96b19ba148ad47afab5b6585e94fd3de/96b19ba148ad47afab5b6585e94fd3de.HD-720p-1.6Mbps-95857205.mp4", "halloween-party-kit": "https://cdn.shopify.com/videos/c/vp/42e97ff81d674fc0857fbe3ea44799e7/42e97ff81d674fc0857fbe3ea44799e7.HD-720p-1.6Mbps-95857206.mp4", "little-spooks-coloring-pages": "https://cdn.shopify.com/videos/c/vp/1799835009e346bcac235bc00bb01c4a/1799835009e346bcac235bc00bb01c4a.HD-720p-1.6Mbps-95857207.mp4", "midnight-candy-mystery-escape-room": "https://cdn.shopify.com/videos/c/vp/6a65b09b1972428189bef04a82ab0960/6a65b09b1972428189bef04a82ab0960.HD-720p-1.6Mbps-95857208.mp4", "murder-at-the-midnight-masquerade": "https://cdn.shopify.com/videos/c/vp/d229b381b4a2438196763332c81c69ca/d229b381b4a2438196763332c81c69ca.HD-720p-1.6Mbps-95857210.mp4", "pumpkin-carving-stencils": "https://cdn.shopify.com/videos/c/vp/94a52f777c1943d885cdbda1b2113ff5/94a52f777c1943d885cdbda1b2113ff5.HD-720p-1.6Mbps-95857211.mp4", "puzzle-and-activity-pack": "https://cdn.shopify.com/videos/c/vp/4246f962cbe4458f82c39807388cde73/4246f962cbe4458f82c39807388cde73.HD-720p-1.6Mbps-95857212.mp4", "spooky-friends-story-pack": "https://cdn.shopify.com/videos/c/vp/aa7d22c8231d4782b92ab16326833cd4/aa7d22c8231d4782b92ab16326833cd4.HD-720p-1.6Mbps-95857213.mp4", "spooky-kids-coloring-pages": "https://cdn.shopify.com/videos/c/vp/d07183bc5d9c4cddadb3868b88b5bdaf/d07183bc5d9c4cddadb3868b88b5bdaf.HD-720p-1.6Mbps-95857214.mp4", "teen-and-tween-party-pack": "https://cdn.shopify.com/videos/c/vp/512312238a7a484f852467a4bd63195d/512312238a7a484f852467a4bd63195d.HD-720p-1.6Mbps-95857215.mp4"};

function ASSET(p) {
  if (p.indexOf("assets/img/friends/") === 0) return CDN + "tp-friend-" + p.slice(19) + VER;
  if (p.indexOf("assets/img/pages/") === 0)   return CDN + "tp-page-"   + p.slice(17) + VER;
  if (p.indexOf("assets/img/inside/") === 0)  return CDN + "tp-inside-" + p.slice(18) + VER;
  if (p.indexOf("assets/img/mockup/") === 0) {
    const s = p.slice(18).replace(".jpg", "");
    if (MOCKUP_NOSTRI.indexOf(s) >= 0) return CDN + "tp-mockup-" + s + ".jpg" + VER;
    const sp = SHOPIFY.prodotti[HANDLE(slugAId(s))];
    return (sp && sp.img) || CDN + s + ".png" + VER;
  }
  if (p.indexOf("assets/video/") === 0) return TP_VIDEO[p.slice(13).replace(".mp4", "")] || "";
  return p;
}

/* id del sito → handle Shopify, e ritorno */
const HANDLE = id => (prod(id) || {}).handle || id;
const slugAId = slug => {
  const p = CAT().prodotti.find(x => x.img === slug || x.id === slug || x.file.indexOf(slug) >= 0);
  return p ? p.id : slug;
};
const SP = id => SHOPIFY.prodotti[HANDLE(id)] || null;

/* ------------------------------------------------------------------ i prezzi */
function fondiPrezzi() {
  CAT().prodotti.forEach(p => {
    const s = SP(p.id);
    if (!s) { console.warn("prodotto non trovato su Shopify:", p.id); return; }
    p.prezzo = s.prezzo;                 // ⬅️ la cifra di Shopify vince sempre
    p.prezzo_testo = s.prezzo_testo;
    p.pieno = s.pieno;
    p.pieno_testo = s.pieno_testo;
    p.variante = s.variante;
    p.disponibile = s.disponibile;
  });
}

/* Formattazione: i prezzi dei prodotti arrivano gia' formattati da Shopify.
   Per le somme calcolate (risparmi, totali) si usa la valuta del Mercato. */
const _fmt = new Intl.NumberFormat(document.documentElement.lang || "en", {
  style: "currency", currency: (window.SHOPIFY && SHOPIFY.valuta) || "EUR"
});


/* Trick or Print — guscio del sito: barra urgenza, menu, cielo, carrello, piè di pagina.
   Il catalogo arriva da catalogo.js (generato da sito/build/dati.py). */

/* ====================================================================== OFFERTA
   ⚠️ UNICO PUNTO DA TOCCARE PER LO SCONTO.
   `sconto` taglia TUTTI i prezzi di listino (Vault compreso) e accende la barra.
   Le righe «bought separately» si ricalcolano da sole sui prezzi in vigore:
   nessun confronto gonfiato, mai.
   ⛔ Se lo sconto è acceso, il 5 ottobre i prezzi devono tornare pieni davvero:
      una scadenza dichiarata e non rispettata è la bugia che contestiamo agli altri. */
const OFFERTA = {
  sconto: 0.20,                       // 0 = nessuno sconto; 0.20 = −20%
  nome: "LAUNCH WEEK",
  fine: "2026-10-04T23:59:59",        // domenica 4 ottobre
  fine_testo: "Sunday, October 4"
};
/* ====================================================================== NEWSLETTER
   ⚠️ UNICO PUNTO DA TOCCARE per lo sconto dell'iscrizione.
   ⛔ DUE COSE NON ESISTONO ANCORA, e senza quelle questo blocco e' una promessa vuota:
      1. il codice `SPOOKY10` dev'essere creato in Shopify, altrimenti alla cassa non vale niente;
      2. gli indirizzi NON vanno da nessuna parte: `iscrivi()` li tiene nel browser di chi
         li scrive e basta. Va collegato a Shopify (customer marketing consent) o a un
         servizio di posta PRIMA di pubblicare. Vedi STATO.md §9.3. */
const NEWSLETTER = {
  sconto: 0.10,
  /* ⛔ Questo deve essere IL CODICE CHE ESISTE SU SHOPIFY, lettera per lettera:
     il sito lo consegna al cliente e la cassa lo deve riconoscere.
     Il 28/09 il sito diceva "SPOOKY10" e in negozio c'era "Spooky" -> rifiutato.
     Il 29/09 la situazione si e' ROVESCIATA: su Shopify esiste "SPOOKY10"
     (attivo, 10%, 1 uso per cliente, non combinabile) e "Spooky" NON esiste piu'
     -> era il sito a consegnare un codice morto.
     `[FATTO, codeDiscountNodeByCode su entrambi, 29/09/2026]` */
  codice: "SPOOKY10",
  /* ⛔ La scadenza VERA del codice in Shopify: 19/10 alle 09:00 CEST, cioe' tutto
     il 18 ottobre in ogni fuso degli USA continentali. Le due righe vanno insieme:
     se cambia la data in Shopify, cambia qui, altrimenti la pagina promette uno
     sconto che la cassa rifiuta. `[FATTO, discountCodeBasicUpdate, 29/09/2026]`
     ⭐ Dopo questa data il pop-up smette DA SOLO di promettere il codice: non
     dipende da nessuno che si ricordi di cambiarlo. */
  scadenza: "2026-10-19T09:00:00+02:00",
  scadenza_testo: "Sunday, October 18",
  scorrimento: 0.35,        // compare dopo aver percorso il 35% della pagina
  attesa: 9000              // ...e comunque non prima di 9 secondi
};

const HALLOWEEN = "2026-10-31T00:00:00";
// ⛔ CHIUSURA tolta il 29/09/2026: al cliente non si dice MAI che il negozio
//    chiude, ne' quando. Non e' solo inopportuno — e' falso: il negozio non chiude.

/* ======================================================================= utili */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const soldi = n => (typeof n === "number" ? _fmt.format(n) : (n || ""));
/* ⛔ Lo sconto non lo decide piu' il sito: e' il «compare at price» di Shopify.
   Uno sconto che la cassa non conosce non esiste. */
const attivo = () => CAT().prodotti.some(p => p.pieno);
const codiceVivo = () => new Date() <= new Date(NEWSLETTER.scadenza);
const prezzoOra = v => v;   /* i prezzi arrivano gia' giusti da Shopify */
const giorniA = d => Math.max(0, Math.ceil((new Date(d) - new Date()) / 864e5));

const CAT = () => window.CATALOGO;
const prod = id => CAT().prodotti.find(p => p.id === id);
const img = p => ASSET(`assets/img/mockup/${p.img}.jpg`);
/* il testo del prezzo lo scrive Shopify: cosi' la valuta e' quella del Mercato */
const prezzoTesto = p => (p && p.prezzo_testo) || soldi(p && p.prezzo);

/* ---------------------------------------------------------------- recensioni
   Il punteggio e il numero stanno in recensioni.js: qui non si scrive nessuna cifra.
   `stelle(4.87)` disegna cinque stelle e ne riempie il 97,4%. */
const REC = () => window.RECENSIONI || null;
const stelle = v => `<span class="stelle" style="--p:${(Math.max(0, Math.min(5, v)) / 5 * 100).toFixed(1)}%">
  <span class="vuote">\u2605\u2605\u2605\u2605\u2605</span><span class="piene">\u2605\u2605\u2605\u2605\u2605</span></span>`;
const mille = n => n.toLocaleString("en-US");

/* la riga «4.87 · 2,147 verified reviews», con il link alla sezione della home */
function valutazione(opt = {}) {
  const r = REC();
  if (!r) return "";
  const link = opt.link === false ? `${mille(r.numero)} verified reviews`
    : `<a href="${opt.base || ""}#reviews">${mille(r.numero)} verified reviews</a>`;
  return `<div class="valuta">${stelle(r.punteggio)}
    <span class="voto">${r.punteggio.toFixed(2)}</span>
    <span class="quante">\u00b7 ${link}</span></div>`;
}

/* ------------------------------------------------------ la scheda di un prodotto */
function scheda(p, opt = {}) {
  const ora = prezzoOra(p.prezzo), sconto = attivo() && ora < p.prezzo;
  const voci = p.voci.slice(0, opt.voci || 3);
  const resto = p.voci.slice(opt.voci || 3);
  return `<article class="card rivela${opt.larga ? " larga" : ""}">
    <div class="foto">
      ${p.badge ? `<span class="etichetta">${p.badge}</span>` : ""}
      ${sconto ? `<span class="etichetta sconto">−${Math.round(OFFERTA.sconto * 100)}%</span>` : ""}
      <a href="/products/${HANDLE(p.id)}"><img src="${img(p)}" alt="${p.nome}" loading="lazy"></a>
    </div>
    <div class="corpo">
      <h3><a href="/products/${HANDLE(p.id)}">${p.nome}</a></h3>
      <div class="eta">${p.eta} · ${p.pdf_n > 1 ? p.pdf_n + " PDF ebooks" : "PDF ebook"}</div>
      <div class="riga-prezzo">
        ${sconto ? `<span class="pagine" style="text-decoration:line-through">${soldi(p.prezzo)}</span>` : ""}
        <span class="prezzo">${soldi(ora)}</span>
        <span class="pagine">· ${p.pagine} pages</span>
      </div>
      <p class="piccolo" style="margin-bottom:8px;color:var(--luna)">${p.gancio}</p>
      <p class="sotto-gancio">${p.sotto}</p>
      <div class="fatti">
        <span><b>${p.pagine}</b> pages</span>
        <span><b>${p.pdf_n}</b> PDF${p.pdf_n > 1 ? "s" : ""}</span>
        ${p.campi ? `<span><b>${p.campi}</b> fillable</span>` : ""}
      </div>
      <ul class="voci">${voci.map(v => `<li>${v}</li>`).join("")}</ul>
      ${resto.length ? `<details class="dentro"><summary>What's inside — every page counted</summary>
        <ul>${resto.map(v => `<li>${v}</li>`).join("")}</ul></details>` : ""}
      <div class="giu">
        <button class="btn fantasma" onclick="Carrello.aggiungi('${p.id}')">Add to bag — ${soldi(ora)}</button>
      </div>
    </div></article>`;
}


/* ================================================================ barra urgenza */
function barra() {
  /* Due messaggi, non di piu': il terzo non lo legge nessuno perche' la barra
     e' gia' tornata al primo. */
  const g = giorniA(HALLOWEEN);
  const vault = prod("complete-halloween-vault");
  /* ⛔ Nessun annuncio di sconto che Shopify non conosce. Se si vuole una
     promozione si mette un «compare at price» sui prodotti: la barra lo mostra da sola. */
  const msg = vault.pieno
    ? [`The Complete Vault: <span class="taglio">${soldi(vault.pieno)}</span> <b class="forte">${soldi(vault.prezzo)}</b> — all ${CAT().totali.prodotti} ebooks`,
       `🎃 Halloween is on a <b>Saturday</b> this year — <b class="forte">${g} days</b> to print`]
    : [`🎃 Halloween is on a <b>Saturday</b> this year — <b class="forte">${g} days</b> to print`,
       `<b>Instant PDF download</b> · print at home, as many times as you like`];

  const b = document.createElement("div");
  b.className = "urgenza";
  b.innerHTML = `<div class="msg">${msg[0]}</div>`;
  document.body.prepend(b);
  let i = 0;
  setInterval(() => {
    i = (i + 1) % msg.length;
    b.innerHTML = `<div class="msg">${msg[i]}</div>`;
  }, 5200);
}

/* ======================================================================= header */
const VOCI = [
  ["/", "Home"], ["/collections/all", "All ebooks"], ["/pages/teachers", "For teachers"],
  ["/pages/about", "About us"], ["/pages/faq", "FAQ"], ["/pages/contact", "Contact"]
];

function testa(pagina) {
  const h = document.createElement("header");
  h.className = "testa";
  h.innerHTML = `<div class="wrap">
    <a class="marchio" href="/">Trick or Print</a>
    <nav class="menu">${VOCI.map(([u, t]) =>
      `<a href="${u}" class="${u.split('#')[0] === pagina ? 'qui' : ''}">${t}</a>`).join("")}</nav>
    <div class="azioni">
      <button class="carrello-btn" aria-label="Cart" onclick="Carrello.apri()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFD166" stroke-width="1.8"
             stroke-linecap="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        <span class="n" id="n-carrello">0</span></button>
      <button class="burger" aria-label="Menu" onclick="document.querySelector('.menu').classList.toggle('aperto')">
        <svg width="20" height="20" viewBox="0 0 24 24" stroke="#FFD166" stroke-width="2" stroke-linecap="round">
          <path d="M3 6h18M3 12h18M3 18h18"/></svg></button>
    </div></div>`;
  document.body.prepend(h);
}

/* ======================================================================== piede */
function piede() {
  const f = document.createElement("footer");
  f.className = "piede";
  f.innerHTML = `<div class="wrap">
    <div class="cols">
      <div>
        <a class="marchio" href="/">Trick or Print</a>
        <p class="piccolo tenue" style="margin-top:14px;max-width:34ch">
          Printable Halloween ebooks for ages 3–12, their teachers and the grown-ups who host.
          Drawn in code, counted page by page.</p>
      </div>
      <div><h5>Shop</h5>
        <a href="/collections/all">All ebooks</a><a href="/#collection">The Coloring Collection</a>
        <a href="/pages/teachers">For teachers</a><a href="/#vault">The Complete Vault</a></div>
      <div><h5>Help</h5>
        <a href="/#reviews">Reviews</a><a href="/pages/faq">FAQ</a><a href="/pages/contact">Contact us</a>
        <a href="/pages/policies#refund">Refund policy</a><a href="/pages/about">About us</a></div>
      <div><h5>Legal</h5>
        <a href="/pages/policies#terms">Terms</a><a href="/pages/policies#privacy">Privacy</a>
        <a href="/pages/policies#license">License</a></div>
    </div>
    <div class="piede-posta">
      <div>
        <h5 style="margin-bottom:6px">${Math.round(NEWSLETTER.sconto * 100)}% off your first download</h5>
        <p class="piccolo tenue" style="margin:0;max-width:40ch">Leave your email and we'll send you a code
          for anything in the shop — plus a note when something new is printable.</p>
      </div>
      <div id="posta-piede"></div>
    </div>
    <div class="fine">
      <span>© 2026 Trick or Print · trickorprint.com</span>
      <span>Prices in ${(window.SHOPIFY && SHOPIFY.valuta) || "EUR"} · All files are US Letter PDFs (8.5 × 11 in)</span>
      <span>Instant download · nothing ships</span>
    </div>
    <div class="fine" style="justify-content:center; gap:34px">
      <a href="/policies/refund-policy">Refund policy</a>
      <a href="/policies/privacy-policy">Privacy policy</a>
      <a href="/policies/terms-of-service">Terms of service</a>
      <a href="/policies/contact-information">Contact information</a>
    </div></div>`;
  document.body.appendChild(f);
}

/* ========================================================================= cielo */
function cielo() {
  const c = document.createElement("div");
  c.className = "cielo";
  let s = "";
  for (let i = 0; i < 130; i++) {
    const x = Math.random() * 100, y = Math.random() * 100, r = Math.random();
    s += `<i class="stella" style="left:${x}%;top:${y}%;--d:${(2 + r * 5).toFixed(1)}s;
      animation-delay:${(r * 5).toFixed(1)}s;opacity:${(.3 + r * .6).toFixed(2)};
      width:${r > .86 ? 3 : 2}px;height:${r > .86 ? 3 : 2}px"></i>`;
  }
  const bat = `<svg viewBox="0 0 64 28" fill="currentColor"><path d="M32 6c-2 4-5 6-9 5-4-1-7-4-11-3-3 1-5 3-6 6 3-1 5 0 6 2 2 3 5 4 8 3 3-1 5-3 8-3 2 0 3 1 4 3 1-2 2-3 4-3 3 0 5 2 8 3 3 1 6 0 8-3 1-2 3-3 6-2-1-3-3-5-6-6-4-1-7 2-11 3-4 1-7-1-9-5z"/></svg>`;
  c.innerHTML = s
    + `<div class="nebbia"></div><div class="nebbia b"></div>`
    + `<div class="pipistrello" style="--t:30s;--r:0s;top:8%">${bat}</div>`
    + `<div class="pipistrello" style="--t:44s;--r:-12s;top:22%;width:24px">${bat}</div>`
    + `<div class="pipistrello" style="--t:36s;--r:-26s;top:4%;width:18px;opacity:.6">${bat}</div>`;
  document.body.prepend(c);
}

/* ------------------------------------------------- i due bottoni che comprano davvero
   Non portano a una pagina: mettono nel carrello e aprono il cassetto. Servono a non
   far girare il cliente per il sito quando ha gia' deciso. */
function bandaCTA(dove, opt = {}) {
  const c = $(dove);
  if (!c) return;
  const core = prod("halloween-coloring-collection"), vault = prod("complete-halloween-vault");
  const bottone = (p, testo, cls) =>
    `<button class="btn ${cls}" onclick="Carrello.aggiungi('${p.id}')">${testo} — ${soldi(prezzoOra(p.prezzo))}</button>`;
  const A = bottone(core, opt.primo || "Get all 3 ebooks", opt.vaultPrima ? "fantasma" : "");
  const B = bottone(vault, opt.secondo || `Or the whole Vault, all ${CAT().totali.prodotti}`,
                    opt.vaultPrima ? "" : "fantasma");
  c.innerHTML = opt.vaultPrima ? B + A : A + B;
}

/* ------------------------------------------------------------------- About us */
function chiSiamo() {
  $("#blocco-noi").innerHTML = `<div class="noi">
    <div class="noi-foto rivela">
      <img src="${ASSET(`assets/img/mockup/complete-halloween-vault.jpg`)}" alt="All fourteen PDFs" loading="lazy">
      <span class="didascalia">Everything we've drawn so far</span>
    </div>
    <div class="rivela">
      <p class="occhiello">About us</p>
      <h2>Who's actually<br>back here</h2>
      <p class="tenue">Trick or Print is one person and a lot of code. No warehouse, no staff, no
        catalogue of things bought in bulk and resold: every page in this shop was drawn here, one at a
        time, and counted before it went in.</p>
      <p class="mini tenue">One thing straight: the ${CAT().totali.pagine_uniche} is the <i>pages</i>.
        The product shots around the shop are mockups of those files.</p>
      <div class="noi-numeri">
        <div><b>${CAT().totali.pagine_uniche}</b><span>pages drawn</span></div>
        <div><b>${CAT().totali.pdf}</b><span>PDF files</span></div>
        <div><b>1</b><span>person</span></div>
      </div>
      <p class="mini tenue">Write to us and a person answers — the same one who drew the pages.</p>
      <div style="margin-top:20px"><a class="btn fantasma" href="/collections/all">See all ${CAT().totali.prodotti} ebooks →</a></div>
    </div></div>`;
}

/* ====================================================================== carrello */
const Carrello = {
  /* ⛔ Il carrello e' quello di Shopify (/cart.js): quello vecchio viveva nel
     browser e non sapeva arrivare alla cassa. `righe` tiene l'ultima lettura. */
  righe: [], totaleCassa: 0,
  dati() { return this.righe.map(r => r.sid).filter(Boolean); },
  async ricarica() {
    try {
      const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      this.righe = c.items.map(i => ({ sid: idDaVariante(i.variant_id), chiave: i.key }));
      this.totaleCassa = c.total_price / 100;
    } catch (e) { console.warn('carrello non leggibile', e); }
    this.disegna();
  },
  salva() { return this.ricarica(); },
  async aggiungi(id) {
    const p = prod(id);
    if (!p || !p.variante) { console.warn('nessuna variante Shopify per', id); return; }
    this.apri();
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variante, quantity: 1 }] }) });
    await this.ricarica();
    // le due regole dell'offerta (STATO §4), applicate sul carrello vero
    const v = this.dati();
    const via = v.includes('complete-halloween-vault')
      ? v.filter(x => x !== 'complete-halloween-vault')
      : (v.includes('classroom-party-edition') && v.includes('candy-free-treats-mini-books')
         ? ['candy-free-treats-mini-books'] : []);
    for (const x of via) await this.togli(x);
  },
  async togli(id) {
    const r = this.righe.find(x => x.sid === id);
    if (!r) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: r.chiave, quantity: 0 }) });
    await this.ricarica();
  },
  totale() { return this.totaleCassa || 0; },
  apri() { $(".velo").classList.add("aperto"); $(".cassetto").classList.add("aperto"); },
  chiudi() { $(".velo").classList.remove("aperto"); $(".cassetto").classList.remove("aperto"); },

  /* Cosa si puo' ancora aggiungere: tutto quello che non e' gia' dentro.
     Regole dell'offerta (STATO §4): chi ha il Vault ha tutto, chi ha la Classroom ha i mini-libri. */
  mancanti() {
    const v = this.dati();
    if (!v.length || v.includes("complete-halloween-vault")) return [];
    return CAT().prodotti.filter(p =>
      p.ruolo !== "vault" && !v.includes(p.id) &&
      !(p.id === "candy-free-treats-mini-books" && v.includes("classroom-party-edition")));
  },

  // il primo e' il bump grande: l'ordine e' quello che aggiunge di piu' al valore del carrello
  bump() {
    const ordine = ["puzzle-and-activity-pack", "31-days-of-halloween", "candy-free-treats-mini-books",
                    "editable-halloween-invitations"];
    const m = this.mancanti();
    for (const id of ordine) { const p = m.find(x => x.id === id); if (p) return p; }
    return m[0] || null;
  },

  /* Lo scambio col Vault: conviene solo se conviene davvero, e il conto si fa
     sui prezzi IN VIGORE. Se non si risparmia, la riga non si mostra. */
  scambioVault() {
    const v = this.dati();
    if (!v.length || v.includes("complete-halloween-vault")) return null;
    const vault = prod("complete-halloween-vault"), ora = prezzoOra(vault.prezzo);
    const tutti = CAT().prodotti.filter(p => p.ruolo !== "vault" && p.id !== "candy-free-treats-mini-books")
      .reduce((s, p) => s + prezzoOra(p.prezzo), 0);
    const risparmio = Math.round((tutti - ora) * 100) / 100;
    return risparmio > 0 ? { vault, ora, risparmio, aggiunta: Math.round((ora - this.totale()) * 100) / 100 } : null;
  },

  disegna() {
    const v = this.dati();
    $("#n-carrello").textContent = v.length;
    const lista = $(".cassetto .lista"), piede = $(".cassetto footer");
    if (!lista) return;
    if (!v.length) {
      lista.innerHTML = `<div class="vuoto"><p style="font-size:2.4rem;margin:0">🕸️</p>
        <p>Your bag is empty.</p><a class="btn piccolo" href="/collections/all">See the ebooks</a></div>`;
      piede.innerHTML = "";
      return;
    }
    lista.innerHTML = v.map(id => {
      const p = prod(id);
      return `<div class="voce"><img src="${img(p)}" alt="">
        <div><div class="n">${p.nome}</div>
          <div class="mini tenue">${p.pdf_n} PDF · ${p.pagine} pages</div></div>
        <div class="via"><b class="giallo">${soldi(prezzoOra(p.prezzo))}</b><br>
          <span onclick="Carrello.togli('${id}')" style="cursor:pointer">remove</span></div></div>`;
    }).join("");

    const b = this.bump();
    const altri = this.mancanti().filter(p => !b || p.id !== b.id);
    const sv = this.scambioVault();
    const pieno = v.reduce((s, id) => s + prod(id).prezzo, 0);
    piede.innerHTML =
      (b ? `<div class="bump"><img src="${img(b)}" alt="">
            <div class="mini"><b>Add ${b.nome}</b><br><span class="tenue">${b.pagine} pages · ${soldi(prezzoOra(b.prezzo))}</span></div>
            <button class="btn piccolo" style="margin-left:auto" onclick="Carrello.aggiungi('${b.id}')">Add</button></div>` : "")
      + (altri.length ? `<div class="altri-carrello">
            <div class="mini tenue" style="margin-bottom:8px">Add anything else — ${altri.length} more</div>
            <div class="fila">${altri.map(p => `<button class="pezzo" title="${p.nome} — ${soldi(prezzoOra(p.prezzo))}"
              onclick="Carrello.aggiungi('${p.id}')"><img src="${img(p)}" alt="${p.nome}">
              <span>+ ${soldi(prezzoOra(p.prezzo))}</span></button>`).join("")}</div></div>` : "")
      + (sv ? `<div class="scambio" onclick="Carrello.aggiungi('${sv.vault.id}')">
            <b class="giallo">Take all ${CAT().totali.prodotti} instead</b>
            <div class="mini tenue">The Complete Vault is ${soldi(sv.ora)} — ${soldi(sv.risparmio)} less than
              buying them one by one${sv.aggiunta > 0 ? `, and only ${soldi(sv.aggiunta)} more than what's in your bag` : ""}.</div>
          </div>` : "")
      + `<div class="totale"><span>Total</span><span class="g">${soldi(this.totale())}</span></div>`
      + (attivo() ? `<p class="mini arancio" style="margin:0 0 10px">${OFFERTA.nome}: you save ${soldi(pieno - this.totale())}</p>` : "")
      + `<button class="btn pieno" onclick="Carrello.paga()">Checkout</button>
         <p class="mini tenue centro" style="margin:12px 0 0">Order today and you can print tonight.</p>`;
  },

  paga() { window.location.href = '/checkout'; },

  monta() {
    this.ricarica();
    document.body.insertAdjacentHTML("beforeend",
      `<div class="velo" onclick="Carrello.chiudi()"></div>
       <aside class="cassetto"><header><h3>Your bag</h3>
         <button class="chiudi" onclick="Carrello.chiudi()" aria-label="Close">×</button></header>
         <div class="lista"></div><footer></footer></aside>`);
    this.disegna();
  }
};

/* ===================================================================== NEWSLETTER */
const Iscrizione = {
  chiave: "top_iscritto_v1",
  chiaveVisto: "top_pop_visto_v1",
  fatta() { try { return !!localStorage.getItem(this.chiave); } catch (e) { return false; } },

  /* Il pop-up si vede UNA VOLTA e basta: il segno resta nel browser, quindi non
     ricompare cambiando pagina, ricaricando, ne' tornando domani. */
  visto() { try { return !!localStorage.getItem(this.chiaveVisto); } catch (e) { return false; } },
  segnaVisto() { try { localStorage.setItem(this.chiaveVisto, Date.now()); } catch (e) {} },

  /* ⛔ Qui finisce la strada: l'indirizzo resta nel browser di chi lo scrive.
     Finche' non c'e' un servizio dietro, NON abbiamo nessuna lista. */
  salva(email) {
    try { localStorage.setItem(this.chiave, email); } catch (e) {}
    console.warn("⛔ NEWSLETTER: l'indirizzo non e' stato spedito a nessuno — manca il collegamento "
               + "a Shopify o a un servizio di posta (STATO.md §9.3). Indirizzo:", email);
  },

  modulo(dove, compatto) {
    const c = $(dove);
    if (!c) return;
    if (this.fatta()) { c.innerHTML = this.fatto(); return; }
    c.innerHTML = `<form class="iscriviti${compatto ? " compatto" : ""}" onsubmit="return Iscrizione.invia(event,this)">
      <input type="email" name="email" required placeholder="you@email.com" aria-label="Your email">
      <button class="btn piccolo" type="submit">${codiceVivo() ? `Get ${Math.round(NEWSLETTER.sconto * 100)}% off` : "Keep me posted"}</button>
    </form>
    <p class="mini tenue" style="margin:8px 0 0">${codiceVivo() ? `Use the code by ${NEWSLETTER.scadenza_testo}. ` : ""}One email when there's something worth printing. No spam, unsubscribe any time.</p>`;
  },

  fatto() {
    return `<div class="codice-dato">
      <div class="mini tenue">Your code — use it at checkout</div>
      <b>${NEWSLETTER.codice}</b>
      <div class="mini tenue">${codiceVivo()
        ? `${Math.round(NEWSLETTER.sconto * 100)}% off. Use it by ${NEWSLETTER.scadenza_testo}.`
        : `This code expired on ${NEWSLETTER.scadenza_testo}.`}</div></div>`;
  },

  invia(e, f) {
    e.preventDefault();
    this.salva(f.email.value.trim());
    $$(".iscriviti").forEach(x => { x.parentNode.innerHTML = this.fatto(); });
    const pop = $(".pop-velo");
    if (pop) setTimeout(() => this.chiudiPop(), 2600);
    return false;
  },

  /* ------------------------------------------------------------------ il pop-up */
  montaPop() {
    if (this.fatta() || this.visto()) return;
    document.body.insertAdjacentHTML("beforeend",
      `<div class="pop-velo" onclick="if(event.target===this)Iscrizione.chiudiPop()">
         <div class="pop" role="dialog" aria-label="${codiceVivo() ? `${Math.round(NEWSLETTER.sconto * 100)}% off` : 'Newsletter'}">
           <button class="chiudi" aria-label="Close" onclick="Iscrizione.chiudiPop()">×</button>
           <div class="pop-luna" aria-hidden="true"></div>
           <p class="occhiello">Before you go</p>
           <h3>${codiceVivo()
             ? `Take another <span class="giallo">${Math.round(NEWSLETTER.sconto * 100)}%</span> off`
             : `One email when it matters`}</h3>
           <p class="tenue">${codiceVivo()
             ? `Drop your email and we'll send you a code you can use on anything in the shop —
             on top of whatever it already costs today. <b>Use it by ${NEWSLETTER.scadenza_testo}.</b>`
             : `Drop your email and we'll tell you when there's something worth printing —
             — one email, not a stream.`}</p>
           <div id="pop-modulo"></div>
         </div></div>`);
    this.modulo("#pop-modulo");

    let mostrato = false;
    const nato = Date.now();
    const forse = () => {
      if (mostrato || this.fatta()) return;
      if (Date.now() - nato < NEWSLETTER.attesa) return;
      if ($(".cassetto")?.classList.contains("aperto")) return;   // mai sopra il carrello
      const h = document.body.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h < NEWSLETTER.scorrimento) return;
      mostrato = true;
      this.segnaVisto();                       // da questo momento non lo rivede piu'
      $(".pop-velo").classList.add("aperto");
      removeEventListener("scroll", forse);
    };
    addEventListener("scroll", forse, { passive: true });
  },

  chiudiPop() { $(".pop-velo")?.classList.remove("aperto"); }
};

/* ==================================================================== rivelazione */
function rivelazione() {
  const io = new IntersectionObserver(e => e.forEach(x => {
    if (x.isIntersecting) { x.target.classList.add("viva"); io.unobserve(x.target); }
  }), { threshold: .12, rootMargin: "0px 0px -8% 0px" });
  $$(".rivela").forEach(el => io.observe(el));
}

/* ========================================================================== onda */
function onda(pos = "top", colore = "rgba(30,17,62,.72)") {
  return `<div class="onda" style="${pos}:-1px;${pos === 'bottom' ? 'transform:rotate(180deg)' : ''}">
    <svg viewBox="0 0 1440 70" preserveAspectRatio="none"><path fill="${colore}"
      d="M0,32 C180,72 360,0 540,14 C720,28 900,66 1080,54 C1230,44 1350,18 1440,8 L1440,0 L0,0 Z"/></svg></div>`;
}

/* ══════════════════════════════ scorrimento automatico delle file orizzontali
   Le recensioni scorrono da sole su telefono. Le condizioni sono tutte «non
   fare niente se non serve», perche' una giostra rotta e' peggio di nessuna:
     ⛔ non parte se l'utente ha chiesto meno animazioni;
     ⛔ non parte se la fila NON scorre davvero (su schermo largo e' una griglia);
     ⛔ non parte due volte sullo stesso elemento;
     ⛔ si ferma appena la tocchi, e riprende da sola dopo qualche secondo.
   Il contenuto viene duplicato una volta sola: cosi' il giro torna all'inizio
   senza salto visibile. Le copie sono `aria-hidden` e senza `.rivela`, o
   resterebbero invisibili in attesa di un'animazione che non arrivera'. */
function scorrimentoAuto() {
  if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  $$(".scorri-auto").forEach(fila => {
    if (fila.dataset.auto === "1" || !fila.children.length) return;
    if (fila.scrollWidth <= fila.clientWidth + 4) return;
    fila.dataset.auto = "1";
    const giro = fila.scrollWidth;                 // ⬅️ prima di duplicare
    [...fila.children].forEach(c => {
      const g = c.cloneNode(true);
      g.setAttribute("aria-hidden", "true");
      g.classList.remove("rivela");
      g.classList.add("viva");
      fila.appendChild(g);
    });
    let fermo = 0, ultimo = 0, attesa;
    const tic = ora => {
      if (!fila.isConnected) return;
      const dt = ultimo ? (ora - ultimo) / 1000 : 0;
      ultimo = ora;
      if (!fermo && dt > 0 && dt < 0.5) {
        fila.scrollLeft += 22 * dt;                // 22 px al secondo: si legge
        if (fila.scrollLeft >= giro) fila.scrollLeft -= giro;
      }
      requestAnimationFrame(tic);
    };
    const pausa = () => { fermo = 1; clearTimeout(attesa); attesa = setTimeout(() => { fermo = 0; }, 3500); };
    ["pointerdown", "touchstart", "wheel"].forEach(e =>
      fila.addEventListener(e, pausa, { passive: true }));
    fila.addEventListener("mouseenter", () => { fermo = 1; });
    fila.addEventListener("mouseleave", () => { fermo = 0; });
    requestAnimationFrame(tic);
  });
}

/* ========================================================================== init */
function avvia(pagina) {
  cielo();
  barra();
  testa(pagina);
  if (typeof contenuto === "function") { try { contenuto(); } catch (e) { console.error("contenuto()", e); } }
  piede();
  Iscrizione.modulo("#posta-piede", true);
  Carrello.monta();
  Iscrizione.montaPop();
  rivelazione();
  // le recensioni possono arrivare un attimo dopo: si riprova una volta
  scorrimentoAuto();
  setTimeout(scorrimentoAuto, 700);
  $$('a[href^="#"]').forEach(a => a.addEventListener("click", () => $(".menu").classList.remove("aperto")));
}
